import { render, staticRenderFns } from "./StudentCourses.vue?vue&type=template&id=f112a83a&scoped=true"
import script from "./StudentCourses.vue?vue&type=script&lang=js"
export * from "./StudentCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f112a83a",
  null
  
)

export default component.exports